import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filtrate-ico",
  "use": "icon-filtrate-ico-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-filtrate-ico\">\r\n<style type=\"text/css\">\r\n\t#icon-filtrate-ico .st0{fill:#888888;}\r\n</style>\r\n<g>\r\n\t<rect x=\"1\" y=\"2\" class=\"st0\" width=\"14\" height=\"2\" />\r\n\t<rect x=\"1\" y=\"7\" class=\"st0\" width=\"14\" height=\"2\" />\r\n\t<rect x=\"1\" y=\"12\" class=\"st0\" width=\"14\" height=\"2\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol